<button
mat-raised-button
matRipple
class="relative !w-full !h-16 !text-xl !overflow-hidden my-1"
#ripple="matRipple"
color="accent"
[disabled]="actionButton.disabled"
(click)="actionButton.action && actionButton.action()"
id="action-button-footer"
[ngClass]="{'glow-effect': showGlow}"
>
  <ng-template #dataLoaded>
    {{ actionButton.label | uppercase }}
  </ng-template>
  <ng-template #loadingData>
    <mat-spinner color="accent" diameter="28"></mat-spinner>
  </ng-template>
  <ng-container [ngTemplateOutlet]="(storeLoaded && userPaymentMethodsLoaded) ? dataLoaded : loadingData"/>
</button>
